import React from 'react';

const StatusContext = React.createContext('status_context');

export default StatusContext;
